import create from 'zustand'

const useSpringStore = create(() => ({
	transitionConfig: { mass: 1, tension: 128, friction: 20, clamp: true },
	revealConfig: { mass: 1, tension: 48, friction: 20, clamp: true },
	backgroundConfig: { mass: 1, tension: 16, friction: 32, clamp: true },
}))

export default useSpringStore
